import { render } from "./LwTourCard.vue?vue&type=template&id=2240afe3&scoped=true"
import script from "./LwTourCard.vue?vue&type=script&lang=js"
export * from "./LwTourCard.vue?vue&type=script&lang=js"

import "./LwTourCard.vue?vue&type=style&index=0&id=2240afe3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2240afe3"]])

export default __exports__